import { render } from "./team.vue?vue&type=template&id=536e2ad4&scoped=true"
import script from "./team.vue?vue&type=script&lang=ts"
export * from "./team.vue?vue&type=script&lang=ts"

import "./team.vue?vue&type=style&index=0&id=536e2ad4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-536e2ad4"

export default script